import { useState, useEffect, useCallback } from "react";
import { makeApiRequest, apiRoutes } from "constants/apiRoutes";
import { useAuth } from "utilities/auth";
import { useEffectiveCompanyId } from "hooks/useEffectiveCompanyId";

export function useApplicationById(id) {
  const [application, setApplication] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const auth = useAuth();
  const companyId = useEffectiveCompanyId();

  const fetchApplication = useCallback(async () => {
    if (!auth.user || !id) return;

    setLoading(true);
    setError(null);

    try {
      const response = await makeApiRequest(
        "get",
        `${apiRoutes.getApplication(id)}`,
        auth.user,
        companyId,
        null
      );

      setApplication(response.data || null);
    } catch (err) {
      console.error(
        "[useApplicationById] Failed to fetch application:",
        err
      );
      setError(err);
      setApplication(null);
    } finally {
      setLoading(false);
    }
  }, [companyId, id]);

  useEffect(() => {
    fetchApplication();
  }, [fetchApplication]);

  return { application, loading, error, refetch: fetchApplication };
}
